// Generated by CoffeeScript 1.12.2
var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

define('views/welcome',['require','underscore','sp/ui/questions/question_view','sp/utilities/markdown_to_html','etc/definitions','text!templates/welcome.html','sp/validator'],function(require) {
  var QuestionView, Validator, Welcome, _, logo, markdownToHtml, template;
  _ = require('underscore');
  QuestionView = require('sp/ui/questions/question_view');
  markdownToHtml = require('sp/utilities/markdown_to_html');
  logo = require('etc/definitions').logo;
  template = require('text!templates/welcome.html');
  Validator = require('sp/validator');
  return Welcome = (function(superClass) {
    extend(Welcome, superClass);

    function Welcome() {
      this.windowResizeHandler = bind(this.windowResizeHandler, this);
      return Welcome.__super__.constructor.apply(this, arguments);
    }

    Welcome.BEGIN_EVENT = 'begin';

    Welcome.prototype.attributes = {
      id: "survey-welcome"
    };

    Welcome.prototype.events = {
      "click #begin-button": "beginButtonClickHandler"
    };


    /**
    		The participants email address
    
    		@property email
    		@type String
    		@default null
     */

    Welcome.prototype.email = null;

    Welcome.prototype.initialize = function(options) {
      Welcome.__super__.initialize.call(this, options);
      this.email = options.email;
      if (!_.isFunction(_.markdownToHtml)) {
        _.mixin({
          markdownToHtml: markdownToHtml
        });
      }
      return this.initListeners();
    };

    Welcome.prototype.render = function() {
      var data;
      data = this.model.toJSON();
      data.definitions = this.definitions;
      if (!data.branding.logo) {
        data.branding.logo = logo.light;
      }
      template = _.template(template)(data);
      this.$el.append(template).hide();
      if (this.email && this.email.length && !this.validate(this.email)) {
        this.$el.find('#welcome-email').val(this.email);
        this.email = null;
      }
      return this.$el;
    };


    /**
    		Checks if the email address provided is valid
    
    		@method validateEmail
    		@return {String|null} an error message if invalid or null if valid
     */

    Welcome.prototype.validate = function(value) {
      var errors, opts, validator;
      opts = {
        name: "welcome-email",
        rules: ['email'],
        label: this.definitions.emailLabel || "Email",
        message: this.definitions.validations.email.replace("%s", this.definitions.emailLabel)
      };
      if (value && value.length) {
        delete opts.name;
        opts.value = value;
      }
      if (this.model.get('email') === 'required') {
        opts.rules.push('required');
      }
      validator = new Validator(opts);
      errors = validator.validate();
      if (errors && errors.length) {
        return errors[0].message;
      } else {
        return null;
      }
    };

    Welcome.prototype.submit = function() {
      var val;
      val = $.trim(this.$el.find('input#welcome-email').val());
      this.email = val && val.length ? val : null;
      if (this.model.get('email') === 'anonymous') {
        this.valid = true;
      } else {
        this.validationError = this.validate();
        this.valid = this.validationError && this.validationError.length ? false : true;
      }
      if (this.valid) {
        $(window).off('resize');
        return this.trigger(Welcome.BEGIN_EVENT, this);
      } else {
        return this.showValidationError(this.validationError);
      }
    };

    Welcome.prototype.beginButtonClickHandler = _.debounce(function(e) {
      e.preventDefault();
      return this.submit();
    }, 500, {
      leading: true,
      trailing: false
    });

    Welcome.prototype.windowResizeHandler = function(e) {
      return this.center();
    };

    Welcome.prototype.initListeners = function() {
      return $(window).resize(this.windowResizeHandler);
    };

    return Welcome;

  })(QuestionView);
});

